import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@zillow/constellation';

import { StyledStatusComponent } from './StyledComponents';

const Status = (props) => {
    // vonComponent - view on network dropdown
    const { tagComponent, vonComponent } = props;

    return (
        <StyledStatusComponent>
            <Flex
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                className="Status"
            >
                {tagComponent}
                {vonComponent}
            </Flex>
        </StyledStatusComponent>
    );
};

Status.propTypes = {
    tagComponent: PropTypes.node.isRequired,
    vonComponent: PropTypes.oneOfType([
        () => null,
        PropTypes.node.isRequired,
    ]),
};

Status.defaultProps = {
    vonComponent: null,
};

export default Status;
